/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Alerts/Info': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M16 25c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9m0-20C9.935 5 5 9.935 5 16s4.935 11 11 11 11-4.935 11-11S22.065 5 16 5m.841 8.576h-1.68c-.099 0-.14.056-.14.14v7.144c0 .084.055.14.14.14h1.68c.098 0 .14-.056.14-.14v-7.144c0-.098-.056-.14-.14-.14m-.84-2.802c-.616 0-1.121.477-1.121 1.093s.505 1.092 1.121 1.092 1.121-.476 1.121-1.092c0-.616-.505-1.093-1.121-1.093"/>'
  }
})
